import React from 'react';
import Buttons from '../button';
import { Link } from "react-router-dom";
import { NavegationMenuContainer,
         NavegationMenu, 
         UserContainer,
         UserName,
         UserMail,
         ContainerDataUser,
         IconUser,
         NavegationList,
         NavegationListItem,
         BlockButtonSignOff
       } from './styles';

class NavegationComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      username: '',
      pass: ''
    };
  }

  render() {

    return (
    <NavegationMenuContainer>
      <NavegationMenu>
        <UserContainer>
          <IconUser src="/images/login.svg" />
          <ContainerDataUser>
          <UserName>
              {localStorage.getItem('username').toUpperCase()}
            </UserName>
            <UserMail>
              {localStorage.getItem('email')}
            </UserMail>
          </ContainerDataUser>
        </UserContainer>
      
        {(localStorage.getItem('perfiles').includes('Admin'))?
        <NavegationList>
          <Link to="/home">
            <NavegationListItem>
              Inicio
            </NavegationListItem>
          </Link>
          
          <Link to="/home/consult/error"> 
            <NavegationListItem>
              Errores
            </NavegationListItem>
          </Link>

          <Link to="/home/consult/instances">
            <NavegationListItem>
              Consulta Instancia
            </NavegationListItem>
          </Link>

          <Link to="/home/report/despachoDigital">
            <NavegationListItem>
              Despacho Digital
            </NavegationListItem>
          </Link>

          <Link to="/home/config/despachoDigital">
            <NavegationListItem>
              Config Despacho Digital
            </NavegationListItem>
          </Link>

          <Link to="/home/config/messenger">
            <NavegationListItem>
              Envio de correos
            </NavegationListItem>
          </Link>
        </NavegationList>
        :
        <NavegationList>
          <Link to="/home/consult/estadoPago">
            <NavegationListItem>
              Consulta Estado Pago
            </NavegationListItem>
          </Link>

          <Link to="/home/report/despachoDigital">
            <NavegationListItem>
              Despacho Digital
            </NavegationListItem>
          </Link>
        </NavegationList>
        }
      </NavegationMenu>
      <BlockButtonSignOff>
        <Buttons.Secondary onClick={this.logout} >Cerrar Sesión</Buttons.Secondary>
    </BlockButtonSignOff>
    </NavegationMenuContainer>
    );
  }

  logout = () => {
    //limpio localstorage
    localStorage.clear();
    //volver al login
    window.location = '/';
  }
  
}

export default NavegationComponent;